import { Card, Box, Avatar, Typography } from "@mui/material";

export default function MomentEndedCard({ data }) {
  return (
    <Card sx={{ p: 2.5, mb: 3, borderRadius: "20px", background: "#FFF" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar src={data.userAAvatar} />
        <Avatar src={data.userBAvatar} />

        <Box>
          <Typography fontWeight={700}>
            {data.userAName} & {data.userBName}
          </Typography>

          <Typography color="text.secondary">
            ended their Moment • {new Date(data.createdAt).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit"
            })}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
